export function getDeliveryStatus(status = '') {
  switch (status) {
    case 'Inprogress':
      return 'In Progress';
    case 'Complete':
      return 'Complete';
    case 'Request':
      return 'Request';
    default:
      return status;
  }
}
